import { Navigate, RouteObject } from "react-router";
import ConfirmationsRoute from "@/routes/processes/[processId]/rlt/confirmations/confirmations-route";
import { ConfirmationRoute } from "@/routes/processes/[processId]/rlt/confirmations/[confirmationId]/confirmation-route";
import { ConfirmationDataRoute } from "@/routes/processes/[processId]/rlt/confirmations/[confirmationId]/data/confirmation-data-route";
import { ConfirmationTreatmentRoute } from "@/routes/processes/[processId]/rlt/confirmations/[confirmationId]/treatment/confirmation-treatment-route";
import { ConfirmationCalculationRoute } from "@/routes/processes/[processId]/rlt/confirmations/[confirmationId]/calculation/confirmation-calculation-route";
import { AddressesAndContactsRoute } from "@/routes/processes/[processId]/rlt/confirmations/[confirmationId]/addresses-and-contacts/addresses-and-contacts-route";

export const confirmationsRoutes: RouteObject[] = [
  {
    index: true,
    element: <ConfirmationsRoute />,
  },
  {
    path: ":confirmationId",
    element: <ConfirmationRoute />,
    children: [
      {
        index: true,
        element: <Navigate to="data" />,
      },
      {
        path: "data",
        element: <ConfirmationDataRoute />,
      },
      {
        path: "treatment",
        element: <ConfirmationTreatmentRoute />,
      },
      {
        path: "calculation",
        element: <ConfirmationCalculationRoute />,
      },
      {
        path: "addresses-and-contacts",
        element: <AddressesAndContactsRoute />,
      },
    ],
  },
];
